/* eslint-disable max-len */
// React-Dates does not have an error prop
// Hack to add an error state with ariaLabel prop
var getBorderColor = props => {
  if (props.ariaLabel === 'date-picker-invalid') return 'error';
  if (props.focused) return 'brand.500';
  return 'adaGray';
};

function styles(props) {
  return {
    // ============================================================================================
    // Root
    // ============================================================================================
    '.SingleDatePicker': {
      position: 'relative',
      display: 'inline-block',
      width: '100%'
    },
    // ============================================================================================
    // Root Input container
    // ============================================================================================
    '.SingleDatePickerInput': {
      display: 'flex',
      width: '100%',
      backgroundColor: 'white',
      // variants
      '&__withBorder': {
        borderBottom: '1px solid',
        borderColor: getBorderColor(props)
      },
      '&__rtl': {
        direction: 'rtl'
      },
      '&__disabled': {
        backgroundColor: 'lightGray'
      },
      '&__block': {
        display: 'block'
      }
    },
    // ======================================================
    // Root - Picker
    // ======================================================
    '.SingleDatePicker_picker': {
      zIndex: 10,
      position: 'absolute',
      shadow: 'base',
      // variants
      '&__rtl': {
        direction: 'rtl'
      },
      '&__directionLeft': {
        left: '0'
      },
      '&__directionRight': {
        right: '0'
      },
      '&__portal': {
        backgroundColor: 'rgba(0,0,0,.3)',
        position: 'fixed',
        top: '0',
        left: '0',
        height: '100%',
        width: '100%'
      },
      '&__fullScreenPortal': {
        background: 'white'
      }
    },
    // ============================================================================================
    // Calendar Day
    // ============================================================================================
    '.CalendarDay': {
      MozBoxSizing: 'border-box',
      boxSizing: 'border-box',
      cursor: 'pointer',
      fontSize: '14px',
      textAlign: 'center',
      _hover: {
        color: 'brand.500'
      },
      _active: {
        outline: '0'
      }
    },
    '.CalendarDay__defaultCursor': {
      cursor: 'default'
    },
    '.CalendarDay__default': {
      color: 'black',
      fontWeight: 700,
      _hover: {
        div: {
          color: 'brand.500'
        }
      }
    },
    // ============================================================================================
    // Calendar Day - today
    // ============================================================================================
    '.CalendarDay__today': {
      position: 'relative',
      borderColor: 'white',
      boxShadow: 'base',
      marginLeft: '9px',
      marginRight: '9px',
      _before: {
        position: 'absolute',
        content: '""',
        width: '70%',
        height: '70%',
        border: '2px solid',
        borderColor: 'gray.700',
        borderRadius: '46%',
        top: '15%',
        left: '15%'
      },
      '&.CalendarDay__selected': {
        borderColor: 'brand.500',
        boxShadow: 'none',
        marginRight: 0,
        _before: {
          border: 0
        }
      }
    },
    // ============================================================================================
    // Calendar Day - selected
    // ============================================================================================
    '.CalendarDay__selected': {
      color: 'white',
      position: 'relative',
      background: 0,
      transformStyle: 'preserve-3d',
      _after: {
        background: 'brand.500',
        position: 'absolute',
        content: '""',
        width: '80%',
        height: '80%',
        border: '5px double',
        borderColor: 'white',
        borderRadius: '46%',
        top: '10%',
        left: '10%',
        transform: 'translateZ(-1px)'
      },
      _hover: {
        color: 'white'
      }
    },
    // ============================================================================================
    // Calendar Day - Disabled out of range
    // ============================================================================================
    '.CalendarDay__blocked_out_of_range': {
      border: '0',
      background: 'white',
      color: 'darkGray',
      fontWeight: 400,
      cursor: 'not-allowed',
      '&:hover': {
        color: 'darkGray'
      }
    },
    // ============================================================================================
    // Calendar Month
    // ============================================================================================
    '.CalendarMonth': {
      background: 'white',
      textAlign: 'center',
      verticalAlign: 'top',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      msUserSelect: 'none',
      userSelect: 'none'
    },
    // ============================================================================================
    // Calendar Month - table
    // ============================================================================================
    '.CalendarMonth_table': {
      borderCollapse: 'collapse',
      borderSpacing: '0',
      marginTop: 2
    },
    // ============================================================================================
    // Calendar Month - Caption
    // ============================================================================================
    '.CalendarMonth_caption': {
      color: 'darkGray',
      fontSize: '18px',
      textAlign: 'center',
      paddingTop: '20px',
      paddingBottom: '32px',
      captionSide: 'initial',
      '& strong': {
        lineHeight: '14px',
        fontSize: '14px',
        color: 'black'
      },
      '&__verticalScrollable': {
        paddingTop: '12px',
        paddingBottom: '7px'
      }
    },
    // ============================================================================================
    // Calendar Month Grid
    // ============================================================================================
    '.CalendarMonthGrid': {
      background: 'white',
      textAlign: 'left',
      zIndex: 0,
      '&__animating': {
        zIndex: 1
      },
      '&__horizontal': {
        position: 'absolute',
        left: '9px'
      }
    },
    // ============================================================================================
    // Calendar Month Grid - month
    // ============================================================================================
    '.CalendarMonthGrid_month': {
      '&__horizontal': {
        display: 'inline-block',
        verticalAlign: 'top',
        minHeight: '100%'
      },
      '&__hideForAnimation': {
        position: 'absolute',
        zIndex: -1,
        opacity: 0,
        pointerEvents: 'none'
      },
      '&__hidden': {
        visibility: 'hidden'
      }
    },
    // ============================================================================================
    // Day Picker
    // ============================================================================================
    '.DayPicker': {
      background: 'white',
      position: 'relative',
      textAlign: 'left',
      minHeight: '320px',
      borderRadius: '10px'
    },
    // ============================================================================================
    // Day Picker - Nav
    // ============================================================================================
    '.DayPickerNavigation': {
      position: 'relative',
      zIndex: 2,
      '&__horizontal': {
        height: '0'
      },
      '&__verticalScrollable_prevNav': {
        zIndex: 1
      },
      '&__verticalScrollableDefault': {
        position: 'relative'
      },
      '&__verticalDefault': {
        position: 'absolute',
        width: '100%',
        height: '52px',
        bottom: '0',
        left: '0'
      },
      '&__bottom': {
        height: 'auto'
      },
      '&__bottomDefault': {
        WebkitBoxPack: 'justify',
        msFlexPack: 'justify',
        display: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
        WebkitJustifyContent: 'space-between',
        justifyContent: 'space-between'
      }
    },
    '.DayPickerNavigation_button': {
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      msUserSelect: 'none',
      userSelect: 'none',
      border: '0',
      padding: '0',
      margin: '0',
      '&__default': {
        backgroundColor: 'white',
        color: '#757575',
        _hover: {
          outline: '2px solid',
          outlineColor: 'lightGray'
        },
        _active: {
          background: 'lightGray'
        }
      },
      '&__disabled': {
        cursor: 'default',
        border: '1px solid',
        borderColor: 'lightGray',
        _active: {
          background: '0 0'
        }
      },
      '&__horizontalDefault': {
        position: 'absolute',
        top: '18px',
        lineHeight: 0.78,
        borderRadius: '3px',
        padding: '6px 9px'
      }
    },
    '.DayPickerNavigation_bottomButton__horizontalDefault': {
      position: 'static',
      margin: '-10px 22px 30px'
    },
    '.DayPickerNavigation_leftButton__horizontalDefault': {
      left: '22px'
    },
    '.DayPickerNavigation_rightButton__horizontalDefault': {
      right: '22px'
    },
    '.DayPickerNavigation_button__verticalDefault': {
      padding: '5px',
      background: 'white',
      boxShadow: '0 0 5px 2px rgba(0,0,0,.1)',
      position: 'relative',
      display: 'inline-block',
      textAlign: 'center',
      height: '100%',
      width: '50%'
    },
    '.DayPickerNavigation_svg': {
      '&__horizontal': {
        height: '19px',
        width: '19px',
        fill: 'midGray',
        display: 'block'
      },
      '&__vertical': {
        height: '42px',
        width: '42px',
        fill: 'darkGray'
      },
      '&__disabled': {
        fill: 'lightGray'
      }
    },
    '.DayPicker_portal__horizontal': {
      boxShadow: 'none',
      position: 'absolute',
      left: '50%',
      top: '50%'
    },
    // ============================================================================================
    // Day Picker
    // ============================================================================================
    '.DayPicker_focusRegion': {
      outline: '0'
    },
    '.DayPicker_calendarInfo__horizontal,\n.DayPicker_wrapper__horizontal': {
      display: 'inline-block',
      verticalAlign: 'top'
    },
    // ============================================================================================
    // Day Picker - week headers
    // ============================================================================================
    '.DayPicker_weekHeaders': {
      position: 'relative',
      '&__horizontal': {
        marginLeft: '9px'
      }
    },
    // ============================================================================================
    // Day Picker - week header
    // ============================================================================================
    '.DayPicker_weekHeader': {
      position: 'absolute',
      top: '58px',
      zIndex: 2,
      textAlign: 'left',
      '&__vertical': {
        left: '50%'
      },
      '&__verticalScrollable': {
        top: '0',
        display: 'table-row',
        borderBottom: '1px solid',
        borderColor: 'lightGray',
        background: 'white',
        marginLeft: '0',
        left: '0',
        width: '100%',
        textAlign: 'center'
      }
    },
    '.DayPicker_weekHeader_ul': {
      listStyle: 'none',
      margin: '1px 0',
      paddingLeft: '0',
      paddingRight: '0',
      fontSize: '14px'
    },
    '.DayPicker_weekHeader_li': {
      display: 'inline-block',
      textAlign: 'center',
      small: {
        fontSize: '14px',
        lineHeight: '14px',
        color: 'darkGray'
      }
    },
    // ============================================================================================
    // Day Picker - Transition Container
    // ============================================================================================
    '.DayPicker_transitionContainer': {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: '3px',
      // variants
      '&__horizontal': {
        WebkitTransition: 'height .2s ease-in-out',
        MozTransition: 'height .2s ease-in-out',
        transition: 'height .2s ease-in-out'
      },
      '&__vertical': {
        width: '100%'
      },
      '&__verticalScrollable': {
        paddingTop: '20px',
        height: '100%',
        position: 'absolute',
        top: '0',
        bottom: '0',
        right: '0',
        left: '0',
        overflowY: 'scroll'
      }
    },
    // ============================================================================================
    // Hide bottom left '?'
    // ============================================================================================
    '.DayPickerKeyboardShortcuts_buttonReset': {
      display: 'none'
    },
    // ============================================================================================
    // Date Input
    // ============================================================================================
    '.DateInput': {
      flex: 'auto',
      '&__small': {
        width: '97px'
      },
      '&__block': {
        width: '100%'
      },
      '&__disabled': {
        background: 'lightGray',
        color: 'lightGray'
      }
    },
    // ============================================================================================
    // Date Input - input
    // ============================================================================================
    '.DateInput_input': {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '24px',
      color: 'darkGray',
      backgroundColor: 'white',
      width: '100%',
      paddingBottom: '2px',
      paddingTop: '6px',
      border: '0',
      borderTop: '0',
      borderRight: '0',
      // borderBottom: '2px solid transparent',
      borderLeft: '0',
      borderRadius: '0',
      // variants
      '&__regular': {
        fontWeight: 'auto'
      },
      '&__small': {
        fontSize: '12px',
        lineHeight: '18px',
        letterSpacing: '.2px',
        padding: '8px 0px 4px'
      },
      '&__readOnly': {
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none'
      },
      '&__focused': {
        outline: '0',
        background: 'white',
        border: '0',
        borderTop: '0',
        borderRight: '0',
        borderLeft: '0',
        width: '100%'
      },
      '&__disabled': {
        background: 'lightGray',
        fontStyle: 'italic'
      }
    },
    '.DateInput_screenReaderMessage': {
      border: '0',
      clip: 'rect(0,0,0,0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: '0',
      position: 'absolute',
      width: '1px'
    },
    // ============================================================================================
    // Date Input - Fang: visual dialogue arrow
    // ============================================================================================
    '.DateInput_fang': {
      position: 'absolute',
      width: '20px',
      height: '10px',
      left: '22px',
      zIndex: 2
    },
    '.DateInput_fangShape': {
      fill: 'white'
    },
    '.DateInput_fangStroke': {
      stroke: 'lightGray',
      fill: 'transparent'
    },
    // ============================================================================================
    // Misc
    // ============================================================================================
    td: {
      padding: '0px'
    }
  };
} // function baseBorderStyle(props: any) {
//   return {
//     borderColor: props.focused ? 'brand.500' : 'adaGray',
//   }
// }


var baseStyle = props => ({
  'datePickerStyles--div': styles(props)
});

export default {
  baseStyle
};
//# sourceMappingURL=DatePicker.js.map